import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey } from '../internal.js'

const credentialTypes = [apiKey] as const

export type poltCredType = (typeof credentialTypes)[number]
export const poltDocumentTypes = [
  'invoice',
  'other',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const polt: CarrierDef<poltCredType> = {
  name: 'Polaris Transport',
  scac: 'polt',
  credentialTypes,
  legacyCredMap: [['api-key', 'apiKey']], // For Engine API
  engineLayers: ['bol', 'documents'],
  documentTypes: poltDocumentTypes,
}
